import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getCategory,
  getParticularPage,
  getNext,
  getPrevious,
  createCategory,
  updateCategory,
  handleSearch,
} from "./thunk";

const initialState = {
  categories: [],
  edit: false,
  category: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingCategory: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    parent: null,
    isActive: true,
  },
  activeCategoryId: null,
};

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    categoryEditSuccess: (state, action) => {
      state.edit = true;
      state.category = state.categories.find((category) => category.id === action.payload);
      state.formData = state.categories.find((category) => category.id === action.payload);
      state.activeCategoryId = action.payload;
    },
    clearAllCategory: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingCategory = false;
      state.category = null;
      state.activeCategoryId = null;
      state.formData = initialState.formData;
    },
    resetCategoryForm: (state, action) => {
      if (action.payload) {
        // if edit is true, reset to category data
        state.formData = state.category;
      } else {
        state.formData = initialState.formData; // if edit is false, reset to initial state
        state.activeCategoryId = null;
      }
    },
    // New reducers for form persistence
    saveCategoryForm: (state, action) => {
      state.formData = action.payload;
    },
    clearCategoryForm: (state) => {
      state.formData = initialState.formData;
      state.activeCategoryId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
      state.formData = initialState.formData; // Clear form on success
    });
    builder.addCase(createCategory.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateCategory.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateCategory.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
      state.formData = initialState.formData; // Clear form on success
    });
    builder.addCase(updateCategory.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getCategory.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingCategory = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCategory.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingCategory = false;
        state.categories = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCategory.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingCategory = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  categoryEditSuccess,
  saveCategoryForm,
  resetCategoryForm,
  clearCategoryForm,
  clearAllCategory,
} = categorySlice.actions;

export default categorySlice.reducer;
